import { DatePicker } from '@mui/lab';
import { Grid } from '@mui/material';
import { AccordionControlData } from 'front-office/view-models/release-id-card';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';

interface ControlDataProps {
  onChange: (
    key: keyof AccordionControlData,
    value: AccordionControlData[keyof AccordionControlData]
  ) => void;
  values?: AccordionControlData;
}

const ControlDataFormComponent = ({ onChange, values }: ControlDataProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <DatePicker
          label="Data rilascio"
          aria-label="Data rilascio"
          value={values?.effectiveDate || null}
          onChange={(date) => {
            onChange('effectiveDate', date);
          }}
          renderInput={(params) => <PmiTextField {...params} fullWidth disabled helperText="" />}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <PmiTextField
          aria-label="Validazione codice fiscale"
          label="Validazione codice fiscale"
          id="validationFiscalCode"
          name="validationFiscalCode"
          fullWidth
          type="text"
          variant="outlined"
          disabled
          value={values?.validationFiscalCode || ''}
          onChange={(event) => onChange('validationFiscalCode', event.target.value)}
        />
      </Grid>
    </Grid>
  );
};

ControlDataFormComponent.displayName =
  'Release id card form - document - control data form component';

const ControlDataForm = memo(ControlDataFormComponent);

export default ControlDataForm;
